import { Directive, inject, TemplateRef } from '@angular/core';

@Directive({
  selector: 'ng-template[solTooltipContent]',
})
export class SolTooltipContentDirective {
  public readonly template = inject<TemplateRef<unknown>>(TemplateRef);
}
